import React from 'react';
import Nav1 from "./Nav1";
import Nav2 from "./Nav2";
import './Header.css';

function Header(){

    return(
        <>
            
            <header>
                <Nav1/>
                <Nav2/>
            </header>
            
        </>
    )
}

export default Header